/*eslint-disable*/
import React from "react";
// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import FormLabel from "@material-ui/core/FormLabel";
import Checkbox from "@material-ui/core/Checkbox";
import InputAdornment from "@material-ui/core/InputAdornment";

// material ui icons
import MailOutline from "@material-ui/icons/MailOutline";
import Contacts from "@material-ui/icons/Contacts";
import Check from "@material-ui/icons/Check";
import Close from "@material-ui/icons/Close";

// core components
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import CustomInput from "components/CustomInput/CustomInput.js";
import Button from "components/CustomButtons/Button.js";
import Card from "components/Card/Card.js";
import CardHeader from "components/Card/CardHeader.js";
import CardText from "components/Card/CardText.js";
import CardIcon from "components/Card/CardIcon.js";
import CardBody from "components/Card/CardBody.js";
import CardFooter from "components/Card/CardFooter.js";
import axios from "../../utils/axiosInstance"; 
// style for this view
import styles from "assets/jss/material-dashboard-pro-react/views/validationFormsStyle.js";

const useStyles = makeStyles(styles);

export default function MyAccount() {
  const classes = useStyles();
  const [loading, setLoading] = React.useState(true);
  const [data, setData] = React.useState([])


  React.useEffect(() => {
    const fetchData = async () =>{
      const token = localStorage.getItem("token");
      setLoading(true);
      try {

        await axios
        .get(`${process.env.REACT_APP_API_URL_PREFIX}/api/v1/admin/account`, {
          headers: {
            Authorization: `Bearer ${token}`,
            "Access-Control-Allow-Origin": "*",
          },
        }).then((res) => {
          console.log(res);
          const data = res.data.data;
          setData(data);
          console.log(data);
        })
      }
      catch (error) {
        console.error(error.message);
        if(error?.response?.data?.message=="For security reasons, we locked your account.Please login to continue"){
          localStorage.removeItem("token");
          window.location.assign("/auth/login-page");
        }
      }
      setLoading(false);
    }

    fetchData();
  }, []);

  return (
    <div>
    {loading && <div>Loading</div>}
    {!loading && (
    <GridContainer>
      <GridItem xs={12} sm={12} md={12}>
        <Card>
          <CardHeader color="rose" icon>
            <CardIcon color="rose">
              <MailOutline />
            </CardIcon>
            <h4 className={classes.cardIconTitle}> MyAccount</h4>
          </CardHeader>
          <CardBody>
            <form>
            <CustomInput
                labelText="First Name *"
                id="registeremail"
                formControlProps={{
                  fullWidth: true,
                  readonly: true,
                }}
                inputProps={{
                  readonly:true,
                  disabled:true,
                  value: data?.firstName,
                }}
              />
              <CustomInput
                labelText="Last Name *"
                id="registeremail"
                formControlProps={{
                  fullWidth: true,
                }}
                inputProps={{
                  readonly:true,
                  disabled:true,
                  value: data?.lastName,
                }}
              />
              <CustomInput
                labelText="Email Address *"
                id="registeremail"
                formControlProps={{
                  fullWidth: true,
                }}
                inputProps={{
                  readonly:true,
                  disabled:true,
                  value: data?.email,
                }}
              />
              <CustomInput
                labelText="Phone Number *"
                id="registeremail"
                inputProps={{
                  readonly:true,
                  disabled:true,
                  value: data?.mobileNumber,
                }}
              />
              <div className={classes.formCategory}>
                <small>*</small> Required fields
              </div>
            </form>
          </CardBody>
        </Card>
      </GridItem>
    </GridContainer>
    )}
    </div>
  )
}